import React, { lazy, Suspense, useRef, useState } from "react";
import styles from "./SettingsOtpVfy.module.css";
import fetchAcTokenData from "../../../APIsControll/fetchAcTokenData";

const Button = lazy(() => import("../Dealers/Button"));

const OTP_LENGTH = 6;

const SettingsOtpVfy = ({
  mode,
  managerId,
  deviceId,
  iPInfo,
  browserName,
  operatinySystem,
  onVerify,
  onClose,
  show,
  otpActoken,
  setOtpAcToken,
}) => {
  const [adminOtp, setAdminOtp] = useState(Array(OTP_LENGTH).fill(""));

  const [settingsOtp, setSettingsOtp] = useState(Array(OTP_LENGTH).fill(""));

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const adminRefs = useRef([]);
  const settingsRefs = useRef([]);

  // =========================
  // OTP CHANGE
  // =========================

  const handleChange = (e, index, type) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const otp = type === "admin" ? [...adminOtp] : [...settingsOtp];

    otp[index] = value;

    if (type === "admin") {
      setAdminOtp(otp);
    } else {
      setSettingsOtp(otp);
    }

    // Auto next focus

    if (value && index < OTP_LENGTH - 1) {
      const refs = type === "admin" ? adminRefs.current : settingsRefs.current;

      refs[index + 1]?.focus();
    }
  };

  // =========================
  // BACKSPACE
  // =========================

  const handleKeyDown = (e, index, type) => {
    const refs = type === "admin" ? adminRefs.current : settingsRefs.current;

    if (e.key === "Backspace" && !e.target.value && index > 0) {
      refs[index - 1]?.focus();
    }
  };

  // =========================
  // PASTE
  // =========================

  const handlePaste = (e, type) => {
    e.preventDefault();

    const pastedData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);

    if (!pastedData) return;

    const otpArray = pastedData.split("");

    while (otpArray.length < OTP_LENGTH) {
      otpArray.push("");
    }

    if (type === "admin") {
      setAdminOtp(otpArray);
    } else {
      setSettingsOtp(otpArray);
    }
  };

  // =========================
  // VERIFY OTP
  // =========================

  // const handleVerify = async () => {
  //   setError("");

  //   if (adminOtp.includes("")) {
  //     setError("Please enter admin OTP.");

  //     return;
  //   }

  //   if (settingsOtp.includes("")) {
  //     setError("Please enter profile OTP.");

  //     return;
  //   }

  //   const adminEmailOtp = adminOtp.join("");

  //   const emailOtp = settingsOtp.join("");

  //   console.log({
  //     adminOtp: adminEmailOtp,
  //     settingsOtp: emailOtp,
  //   });

  //   try {
  //     setLoading(true);

  //     // =========================
  //     // HEADERS
  //     // =========================

  //     const myHeaders = new Headers();

  //     myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);

  //     myHeaders.append("actoken", otpActoken);

  //     myHeaders.append("Content-Type", "application/json");

  //     // =========================
  //     // BODY
  //     // =========================

  //     const raw = JSON.stringify({
  //       managerId,

  //       deviceId,

  //       ip: iPInfo?.ip || "192.168.1.6",

  //       browser: browserName || "Chrome",

  //       os: operatinySystem || "Windows",

  //       city: iPInfo?.city || "Lucknow",

  //       state: iPInfo?.region || "Uttar Pradesh",

  //       country: iPInfo?.country_name || "India",

  //       adminEmailOtp,

  //       emailOtp,
  //     });

  //     console.log("REQUEST BODY:", raw);

  //     // =========================
  //     // API CALL
  //     // =========================

  //     const response = await fetch(
  //       `${process.env.REACT_APP_URL}admin/getSettings`,
  //       {
  //         method: "POST",

  //         headers: myHeaders,

  //         body: raw,

  //         redirect: "follow",
  //       },
  //     );

  //     const result = await response.json();

  //     console.log("VERIFY RESPONSE:", result);

  //     if (result?.status === "success") {
  //       onVerify?.(result?.token);
  //     } else {
  //       setError(result?.msg || "Invalid OTP");

  //       show?.(result?.msg || "Invalid OTP");
  //     }
  //   } catch (error) {
  //     console.log("VERIFY ERROR:", error);

  //     setError("OTP verification failed");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleVerify = async () => {
    setError("");

    // VALIDATION

    if (adminOtp.includes("")) {
      setError("Please enter admin OTP.");

      return;
    }

    if (settingsOtp.includes("")) {
      setError("Please enter profile OTP.");

      return;
    }

    try {
      setLoading(true);

      // OTP

      const adminEmailOtp = adminOtp.join("");

      const emailOtp = settingsOtp.join("");

      // API DATA

      const payload = {
        managerId,
        deviceId,
        ip: iPInfo?.ip,
        browser: browserName,
        os: operatinySystem,
        city: iPInfo?.city,
        state: iPInfo?.region,
        country: iPInfo?.country_name,
        adminEmailOtp,
        emailOtp,
      };

      console.log("REQUEST:", payload);

      // API CALL

      const result = await fetchAcTokenData(
        "admin/settings",
        payload,
        otpActoken,
      );

      console.log("RESPONSE:", result);

      // SUCCESS

      if (result?.status === "success") {
        onVerify?.(result?.actoken);
      } else {
        setError(result?.msg || "Invalid OTP");
      }
    } catch (error) {
      console.log(error);

      setError("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // RENDER OTP
  // =========================

  const renderOtpInputs = (otp, type, refs) => {
    return (
      <div className={styles.otpContainer}>
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (refs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            className={styles.otpInput}
            onChange={(e) => handleChange(e, index, type)}
            onKeyDown={(e) => handleKeyDown(e, index, type)}
            onPaste={(e) => handlePaste(e, type)}
          />
        ))}
      </div>
    );
  };

  return (
    <div className={`${styles.modalCard} ${mode ? styles.dark : styles.light}`}>
      {/* CLOSE BUTTON */}

      <button className={styles.closeBtn} onClick={onClose}>
        ×
      </button>

      {/* HEADER */}

      <div className={styles.header}>
        <h2 className={styles.title}>OTP Verification</h2>

        <p className={styles.subTitle}>Verify both OTPs to continue</p>
      </div>

      {/* ADMIN OTP */}

      <div className={styles.section}>
        <label className={styles.label}>Admin Email OTP</label>

        {renderOtpInputs(adminOtp, "admin", adminRefs)}
      </div>

      {/* PROFILE OTP */}

      <div className={styles.section}>
        <label className={styles.label}>Profile Email OTP</label>

        {renderOtpInputs(settingsOtp, "settings", settingsRefs)}
      </div>

      {/* ERROR */}

      {error && <div className={styles.errorBox}>{error}</div>}

      {/* BUTTON */}

      <div className={styles.footer}>
        <Suspense fallback={<button>Loading...</button>}>
          <Button
            type="button"
            buttonClick={handleVerify}
            disabled={loading}
            buttonText={loading ? "Verifying..." : "Verify OTP"}
            buttonBgColor="#4164E3"
            buttonTextColor="#ffffff"
            buttonBorder="none"
            loading={loading}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default SettingsOtpVfy;
